import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=ce7d0262&"
import script from "./contactWay.vue?vue&type=script&lang=js&"
export * from "./contactWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7d0262')) {
      api.createRecord('ce7d0262', component.options)
    } else {
      api.reload('ce7d0262', component.options)
    }
    module.hot.accept("./contactWay.vue?vue&type=template&id=ce7d0262&", function () {
      api.rerender('ce7d0262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/contactWay.vue"
export default component.exports